import { render, staticRenderFns } from "./tripremark.vue?vue&type=template&id=088670d9&scoped=true"
import script from "./tripremark.vue?vue&type=script&lang=js"
export * from "./tripremark.vue?vue&type=script&lang=js"
import style0 from "./tripremark.vue?vue&type=style&index=0&id=088670d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088670d9",
  null
  
)

export default component.exports